import { useEffect } from "react";
import Header from "../components/landing/Header";
import Hero from "../components/landing/Hero";
import ProblemSolution from "../components/landing/ProblemSolution";
import Modules from "../components/landing/Modules";
import MetricsAudience from "../components/landing/MetricsAudience";
import MethodComparison from "../components/landing/MethodComparison";
import SecurityCtaFaq from "../components/landing/SecurityCtaFaq";
import ContactFooter from "../components/landing/ContactFooter";
import { setPageMeta } from "../lib/seo";

export default function Landing() {
    useEffect(() => {
        setPageMeta({
            title:
                "TecSuite — Software gestionale per aziende IT, MSP e system integrator",
            description:
                "TecSuite è il gestionale operativo per aziende IT, MSP e system integrator: interventi, rapportini, contratti di assistenza, licenze, dispositivi, portale cliente e KPI in un'unica piattaforma.",
            canonical: "https://tecsuite.it/",
        });

        // IntersectionObserver for scroll reveals
        const els = document.querySelectorAll(".reveal");
        if (!("IntersectionObserver" in window) || els.length === 0) {
            els.forEach((el) => el.classList.add("is-visible"));
            return;
        }
        const io = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        entry.target.classList.add("is-visible");
                        io.unobserve(entry.target);
                    }
                });
            },
            { threshold: 0.12, rootMargin: "0px 0px -40px 0px" }
        );
        els.forEach((el) => io.observe(el));
        return () => io.disconnect();
    }, []);

    return (
        <div data-testid="landing-page" className="relative">
            <Header />
            <main>
                <Hero />
                <ProblemSolution />
                <Modules />
                <MetricsAudience />
                <MethodComparison />
                <SecurityCtaFaq />
                <ContactFooter />
            </main>
        </div>
    );
}
